import { Link } from "react-router-dom";
import Tag from "@/components/base/Tag";

export interface FeedItem {
  id: string;
  type: string;
  title: string;
  excerpt: string;
  cover: string;
  tags: string[];
  author: string;
  source: string;
  publishedAt: string;
  views?: number;
  plays?: number;
  duration?: string;
}

interface ContentCardProps {
  item: FeedItem;
  tagVariant?: "primary" | "accent" | "secondary";
}

export function formatViews(value?: number) {
  if (!value) return "0";
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}

export default function ContentCard({ item, tagVariant = "secondary" }: ContentCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 我爱搞`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3">
          <Tag label={item.tags[0]} variant={tagVariant} />
        </span>
        {item.duration ? (
          <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs text-background-50">
            {item.duration}
          </span>
        ) : null}
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base line-clamp-2">
          {item.title}
        </h3>
        <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500 md:text-sm line-clamp-2">
          {item.excerpt}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-user-3-line text-[13px]"></i>
            </span>
            {item.author}
          </span>
          <span className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-calendar-line text-[13px]"></i>
              </span>
              {item.publishedAt}
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}